import { useGlobalSearchParams } from "expo-router";

// Purposely separate from conversation.ts so it can be directly imported,
// shrinking the dependency tree for Chromatic snapshots.
export const useCurrentConversationId = () => {
  const { id } = useGlobalSearchParams<{
    id?: string;
  }>();
  return id;
};
